import axios from 'axios';
import { useCallback } from 'react';

const loadData = async (url: string) => {
  return await axios.get(url, {
    responseType: 'blob'
  });
};

const useFetchPdf = () => {
  const loadPdf = useCallback((url: string) => {
    return loadData(url);
  }, []);

  return loadPdf;
};

export default useFetchPdf;
